<template>
    <va-create-layout>
        <MwsSynchronization-form
            :title="title"
            :item="item"
        ></MwsSynchronization-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
